/**
 * Token 自动刷新配置
 * 
 * 根据你的后端API情况，调整以下配置：
 */

export const TOKEN_CONFIG = {
  // ============= 基本配置 =============
  
  // Token存储的localStorage键名
  TOKEN_KEY: 'receptionToken',
  REFRESH_TOKEN_KEY: 'receptionRefreshToken',
  
  // ============= 过期检测配置 =============
  
  // Token过期的HTTP状态码
  EXPIRED_STATUS_CODES: [401],
  
  // Token过期的业务状态码 (根据你的后端API调整)
  EXPIRED_BUSINESS_CODES: [401, 4001, 1001], // 常见的token过期业务码
  
  // Token过期的错误消息关键词 (用于模糊匹配)
  EXPIRED_MESSAGE_KEYWORDS: ['token', 'expired', '过期', '失效', 'unauthorized'],
  
  // ============= 刷新策略配置 =============
  
  // 是否启用refresh token机制（当前后端没有此接口，设为false）
  ENABLE_REFRESH_TOKEN: false,
  
  // Refresh Token API 端点（当前未使用）
  REFRESH_TOKEN_ENDPOINT: '/auth/refresh',
  
  // 启用自动重新登录（适合展示型网站）
  ENABLE_AUTO_RELOGIN: true,
  
  // 自动重新登录的用户凭据
  AUTO_LOGIN_CREDENTIALS: {
    userName: "font-user",
    password: "admin"
  },
  
  // ============= 请求重试配置 =============
  
  // 最大重试次数
  MAX_RETRY_COUNT: 1,
  
  // 并发请求等待超时时间 (毫秒)
  CONCURRENT_REQUEST_TIMEOUT: 10000,
  
  // ============= 调试配置 =============
  
  // 是否启用详细日志
  ENABLE_DEBUG_LOGS: process.env.NODE_ENV === 'development',
  
  // ============= 错误处理配置 =============
  
  // Token刷新失败后是否跳转到登录页（展示型网站建议false）
  REDIRECT_TO_LOGIN_ON_FAILURE: false,
  
  // 登录页路由路径
  LOGIN_ROUTE: '/login',
  
  // 是否显示token刷新相关的用户提示（建议false保持无感知）
  SHOW_USER_NOTIFICATIONS: false,
};

/**
 * 根据响应判断是否为token过期错误
 * @param {Object} error - axios错误对象
 * @returns {boolean}
 */
export const isTokenExpiredError = (error) => {
  if (!error.response) return false;
  
  const { status, data } = error.response;
  
  // 检查HTTP状态码
  if (TOKEN_CONFIG.EXPIRED_STATUS_CODES.includes(status)) {
    return true;
  }
  
  // 检查业务状态码
  if (data && data.code && TOKEN_CONFIG.EXPIRED_BUSINESS_CODES.includes(data.code)) {
    return true;
  }
  
  // 检查错误消息关键词
  if (data && data.msg) {
    const message = data.msg.toLowerCase();
    return TOKEN_CONFIG.EXPIRED_MESSAGE_KEYWORDS.some(keyword => 
      message.includes(keyword.toLowerCase())
    );
  }
  
  return false;
};

export default TOKEN_CONFIG; 


// WEBPACK FOOTER //
// ./src/utils/tokenConfig.js